import { useEffect, useState } from "react";
import { getIcon } from "../../../../utils/amenities";

const Amenities = ({ amenities }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    setItems([...amenities]);
  }, [amenities]);

  if (!items.length) return null;

  return (
    <div className="w-full mt-4 sm:mt-6 md:mt-8 ">
      <div className="bg-white p-4 md:p-6 lg:p-8 w-full mx-auto rounded-lg border">
        {/* Title */}
        <h2 className="font-medium text-[#031722] tracking-[0.01em] text-lg sm:text-xl md:text-2xl lg:text-3xl mb-1 sm:mb-2 md:mb-3 lg:mb-4">
          Amenities
        </h2>

        {/* Divider */}
        <div className="border-t border-gray-300 mb-3 sm:mb-4 md:mb-6 lg:mb-8"></div>

        {/* Amenity Grid */}
        <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-2 sm:gap-3 md:gap-4 lg:gap-5 xl:gap-6">
          {amenities.map((item, index) => (
            <div
              key={item?.key || index}
              className="flex flex-col items-center justify-center bg-white rounded-xl border border-gray-200 hover:border-blue-300 hover:shadow-md transition-all duration-300 p-2 sm:p-3 md:p-4 lg:p-5 xl:p-6 aspect-square group"
            >
              <img
                src={getIcon(item?.key)}
                alt={item?.label}
                className="w-8 h-8 sm:w-9 sm:h-9 grayscale md:w-10 md:h-10 lg:w-11 lg:h-11 object-contain group-hover:scale-110 transition-transform duration-300"
              />

              <span className="font-medium text-[#545454] tracking-[0.01em] leading-[150%] text-center text-[11.14px] mt-1 sm:mt-2">
                {item?.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Amenities;

// const Amenities = ({ property, showIcons = false }) => {
  // const amenities = property?.property?.amenities;

  // if (!amenities || amenities.length === 0) return null;

  // const filteredAmenities = amenities.flatMap((amenity) =>
  //   amenity.descriptions.map((desc) => ({
  //     type: amenity.type,
  //     label: desc,
  //   }))
  // );

  // return (
  //   <div className="w-full">
  //     <div className="bg-background-card rounded-xl border border-border   shadow-sm overflow-hidden">
  //       <div className="p-5 sm:p-6">
  //         <h2 className="font-medium text-2xl tracking-[0.01em] text-gray-900 mb-3">
  //           Amenities
  //         </h2>

  //         {/* Amenities Grid */}
  //         <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-4">
  //           {filteredAmenities.map((amenity, index) => {
  //             const words = amenity.label.split(" ");
  //             const initials =
  //               words.length > 1
  //                 ? words[0][0] + words[1][0]
  //                 : amenity.label.substring(0, 2);

  //             return (
  //               <div
  //                 key={index}
  //                 className="group relative bg-white border-2 border-border rounded-xl p-4 hover:border-primary hover: shadow-sm transition-all duration-300 cursor-pointer overflow-hidden"
  //               >
  //                 {/* Animated background */}
  //                 <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

  //                 {/* Top indicator */}
  //                 <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-primary to-btn-primary transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>

  //                 <div className="relative z-10 flex flex-col items-center text-center">
  //                   <div className="w-14 h-14 mb-3 flex items-center justify-center rounded-full bg-gradient-to-br from-primary/10 to-primary/5 border-2 border-primary/20 group-hover:border-primary/40 transition-all duration-300">
  //                     <span className="font-audiowide text-primary text-lg font-bold group-hover:scale-110 transition-transform duration-300">
  //                       {initials.toUpperCase()}
  //                     </span>
  //                   </div>

  //                   {/* Label */}
  //                   <h3 className="font-quicksand font-semibold text-sm text-text-primary group-hover:text-primary transition-colors duration-300 leading-tight px-1">
  //                     {amenity.label}
  //                   </h3>

  //                   {/* Category tag */}
  //                   <span className="mt-2 px-2 py-0.5 bg-background rounded-full text-[10px] font-medium text-text-muted opacity-0 group-hover:opacity-100 transition-opacity duration-300">
  //                     {amenity.type}
  //                   </span>
  //                 </div>
  //               </div>
  //             );
  //           })}
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );
// };
// export default Amenities;
